export default "__VITE_ASSET__eae10734__$_?nuxt_component=async__"